module.exports = __webpack_public_path__ + "static/media/vida-adulta-transicion.396471be.jpg";